
<template>  
  <div class="input input--email">
    <label v-if="label">{{ label }}</label>
    <input type="email" :placeholder="placeholder" v-model="currentValue"/>
  </div>
</template>

<script>
import TextInput from '@/scripts/components/forms/TextInput.vue'

export default {
  name: 'NumberInput',
  extends: TextInput
}
</script>

<style scoped lang="scss">
</style>
